import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Navbar,
  Nav,
  Container,
  NavDropdown,
  Image,
  Alert,
} from "react-bootstrap";
import { FiAlertTriangle } from "react-icons/fi";
import { logout } from "../actions/userActions";
import { useNavigate } from "react-router-dom";

const Header = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const clinicDetails = useSelector((state) => state.clinicDetails);
  const { clinic } = clinicDetails;

  const logoutHandler = () => {
    dispatch(logout());
  };
  //innovarauco.cl
  const fullURL = window.location.href;
  useEffect(() => {
    if (
      process.env.NODE_ENV === "production" &&
      !fullURL.includes("cliniceasy.org")
    ) {
      // Redirect to a non-existent domain to simulate "This site can't be reached"
      window.location.href = "http://nonexistent.invalid";
    }
  }, [fullURL]);

  return (
    <>
      {clinic && clinic.isActive === false && (
        <Alert variant="danger" className="text-center m-0">
          <FiAlertTriangle size={30} /> Clinic subscription is inactive. Please{" "}
          <span
            style={{ cursor: "pointer", textDecoration: "underline" }}
            onClick={() =>
              window.open(
                "https://wa.me/+201062048812?text=How to pay subscription fee?",
              )
            }
          >
            pay subscription fee
          </span>{" "}
          to continue enjoying full access.
        </Alert>
      )}
      <header>
        <Navbar collapseOnSelect bg="dark" variant="dark" expand="lg">
          <Container>
            <div
              onClick={() => {
                navigate("/");
              }}
            >
              <Nav.Link>
                <Image src="/favicon-32x32.png" alt="clinic easy" fluid />
              </Nav.Link>
            </div>
            <div
              onClick={() => {
                navigate("/");
              }}
            >
              <Navbar.Brand>
                <span className="lead" style={{ color: "#00abff" }}>
                  ClinicEasy
                </span>
              </Navbar.Brand>
            </div>
            <Navbar.Toggle aria-controls="responsive-navbar-nav" />

            <Navbar.Collapse id="responsive-navbar-nav">
              <Nav className="ml-auto text-right">
                <Nav.Link
                  eventKey={2}
                  className="mx-1 text-white"
                  onClick={() => navigate("/")}
                >
                  Home
                </Nav.Link>

                <Nav.Link
                  eventKey={2}
                  className="mx-1 text-white"
                  onClick={() => navigate("/price-screen")}
                >
                  Price
                </Nav.Link>
                <Nav.Link
                  eventKey={2}
                  className="mx-1 text-white"
                  onClick={() => navigate("/برنامج-العيادة")}
                >
                  About
                </Nav.Link>

                {userInfo ? (
                  <NavDropdown
                    active
                    title={`${userInfo.firstName} ${userInfo.lastName}`}
                    id="username"
                  >
                    <NavDropdown.Item
                      className="text-right"
                      eventKey={2}
                      onClick={() => {
                        navigate("/profile");
                      }}
                    >
                      Profile
                    </NavDropdown.Item>

                    <NavDropdown.Item
                      className="text-right"
                      eventKey={2}
                      onClick={logoutHandler}
                    >
                      Logout
                    </NavDropdown.Item>
                  </NavDropdown>
                ) : (
                  <Nav.Link
                    eventKey={2}
                    className="mx-1 text-white"
                    onClick={() => navigate("/register-screen")}
                  >
                    Create Account | Login
                  </Nav.Link>
                )}

                {/* <Nav.Link
                  eventKey={2}
                  className="mx-1 text-white"
                  onClick={() => navigate("/about")}
                >
                  About
                </Nav.Link> */}
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </header>
    </>
  );
};

export default Header;
